import React from "react";

export interface ServiceCardProps {
  title: string;
  description: string;
}

export function ServiceCard({ title, description }: ServiceCardProps): React.ReactElement {
  return (
    <article className="bg-white border-t-4 border-gold rounded-lg p-6 flex flex-col items-center justify-center min-h-[250px] text-center shadow-sm transition-all duration-200 ease-out hover:shadow-lg hover:-translate-y-1">
      <h3 className="text-navy text-3xl font-medium tracking-tight mb-4">
        {title}
      </h3>
      <p className="text-gray-body text-lg font-medium leading-relaxed flex-1">
        {description}
      </p>
    </article>
  );
}

export default ServiceCard;
